import instance from "../utils/network";
import { createFormData } from "../utils/formData";

export interface MileageHistoryResponse {
  id: number;
  memberId: number;
  nickname: string;
  productName: string;
  price: number;
  createdAt: string;
}

export interface MileageMenuResponse {
  pubId: number;
  name: string;
  price: number;
  id: number;
  imageUrl?: string;
  order?: number;
}

export interface MileageMenuRequest {
  pubId: number;
  name: string;
  price: number;
}

export interface MileageMenuPayRequest {
  pubProductId: number;
  memberId: number;
}

export function getMileageHistory(
  pubId: number
): Promise<MileageHistoryResponse[]> {
  return instance.get(`/seller/pub-product/member-purchase?pubId=${pubId}`);
}

export function getMileageMenu(pubId: number): Promise<MileageMenuResponse[]> {
  return instance.get(`/seller/pub-product?pubId=${pubId}`);
}

export function addMileageMenu(
  data: MileageMenuRequest,
  imageFile?: File
): Promise<any> {
  const formData = createFormData({
    pubId: data.pubId.toString(),
    name: data.name,
    price: data.price.toString(),
  });

  if (imageFile) {
    formData.append("file", imageFile);
  }

  return instance.post(`/seller/pub-product`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function editMileageMenu(
  id: number,
  data: MileageMenuRequest,
  imageFile?: File
): Promise<any> {
  const formData = createFormData({
    pubId: data.pubId.toString(),
    name: data.name,
    price: data.price.toString(),
  });

  if (imageFile) {
    formData.append("file", imageFile);
  }

  return instance.put(`/seller/pub-product/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function deleteMileageMenu(id: number): Promise<any> {
  return instance.delete(`/seller/pub-product/${id}`);
}

export function MileageMenuPay(data: MileageMenuPayRequest): Promise<any> {
  return instance.post(`/seller/pub-product/pay`, data);
}

export function MileageMenuPayMany(
  data: MileageMenuPayRequest[]
): Promise<any> {
  return instance.post(`/seller/pub-product/pay-many`, data);
}

export function MileageMenuRefund(id: number): Promise<any> {
  return instance.post(`/seller/pub-product/refund?memberPurchaseId=${id}`);
}

export function updatePubProductOrders(
  pubId: number,
  productOrders: { id: number; order: number }[]
): Promise<any> {
  return instance.post(`/seller/pub-product/update-order`, {
    pubId,
    productOrders,
  });
}
